export default __webpack_public_path__ + "static/media/login.27188fe8.svg";